module.exports = __webpack_public_path__ + "img/tzlogo.9ddbebc9.png";